<script lang="ts">
	import Popover from '$lib/components/Popover/Popover.svelte';
	import { page } from '$app/stores';
	import Icon from '$lib/components/Icon/Icon.svelte';
	import { _ } from 'svelte-i18n';
	import { linkToggle } from '$lib/actions/linkToggle';
	import type { Hub } from '$lib/api/rpc';
	import type { Writable } from 'svelte/store';

	export let hub: Writable<Hub>;

	let settings = `${$page.params.hubPrefix}/settings`;
</script>

<Popover position="bottom-inline-start">
	<Icon clickable icon="settings" size="24" color={$hub.theme.headerIconColor} slot="target" />
	<ul slot="content">
		<li>
			<a rel="external" href="/{settings}/hub/profile?app=next"
				><Icon icon="settings" size={'24'} color={'black'} /><span>{$_('common.settings')}</span></a
			>
		</li>
		<li>
			<a use:linkToggle={$page} href="/{settings}/design/cover"
				><Icon icon="design" size={'24'} color={'black'} /><span>{$_('hubs.settings.design')}</span
				></a
			>
		</li>
		<li>
			<a href="/{settings}/collections"
				><Icon icon="tags" size={'24'} color={'black'} /><span
					>{$_('hubs.collections.and.tags')}</span
				></a
			>
		</li>
		{#if $hub.settings.feature.nextGenUI != true}
			<li>
				<a rel="external" href="/{settings}/widgets?app=bluesuede"
					><Icon icon="ctas" size={'24'} color={'black'} /><span>{$_('hubs.settings.widgets')}</span
					></a
				>
			</li>
		{/if}
		<li>
			<a href="/{settings}/integrations"
				><Icon icon="integrations" size={'24'} color={'black'} /><span
					>{$_('hub.settings.integrations')}</span
				></a
			>
		</li>
		{#if $hub.type == 'sparq3member'}
			<li>
				<a href="/{settings}/member-data"
					><Icon icon="profile" size={'24'} color={'black'} /><span
						>{$_('hub.settings.memberData')}</span
					></a
				>
			</li>
		{/if}
		<li>
			<a href="/{$page.params.hubPrefix}/group/collaborators"
				><Icon icon="team" size={'24'} color={'black'} /><span>{$_('common.team')}</span></a
			>
		</li>
	</ul>
</Popover>

<style>
	li {
		border-block-end: 1px solid var(--grayLighter);
	}

	li span {
		color: var(--grayDark);
	}

	li:last-child {
		border-block-end: none;
	}

	li a {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		inline-size: 200px;
		padding-block: var(--gutterSmall);
		padding-inline: var(--gutterMedium);
		color: var(--grayDark);
		font-size: var(--fontSizeSmall);
		text-decoration: none;
	}

	li a span {
		margin-block: 0 !important;
		margin-inline: var(--gutterSmall) !important;
	}

	li a:hover {
		background-color: var(--grayLighter);
	}
</style>
